// 感知basePath，返回相对路径
const getInnerUrl = (url: string) => {
  return (process.env.NEXT_PUBLIC_PUBLIC_PATH ?? '') + url;
};

export default getInnerUrl;
